export const rubric = [
  // phase 1
  'b', 'a', 'c', 'c', 'a',
  'b', 'c', 'a', 'b', 'c',
  'b', 'b', 'a', 'b', 'a',
  'c', 'a', 'c', 'b', 'b',
  'c', 'c', 'a', 'b', 'a',

  //phase 2
  'c', 'a', 'c', 'b', 'a',
  'c', 'b', 'c', 'b', 'c',
  'a', 'b', 'c', 'a', 'b',
  'c', 'c', 'b', 'a', 'c',
  'b', 'a', 'a', 'b', 'c',
]